<template>
  <div>
    <div class="category-field-wrapper mt-3">
      <draggable class="drag-category-editor mt-4" v-model="layoutArray" @start="drag=true" @end="drag=false, saveCategoryLayout()">
        <div v-for="(fieldLayoutValues, index) in layoutArray" class="pt-3 pb-3 pl-2 pr-2" :class="(index%2) ? 'odd' : 'even'" >
          <div class="d-inline-block align-middle move pl-3 pr-2 cursor-pointer"><i class="fa fa-arrows-v"></i></div>
          <category_builder_item :field_layout_values="fieldLayoutValues" index="index" :all_textarea_fields="all_textarea_fields" :used_textarea_fields="used_textarea_fields"></category_builder_item>
        </div>
      </draggable>
      <p v-if="layoutArray == ''">To build your judge layout, select a field type from the list below.</p>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-4 mb-3 pb-5">
      <button @click.prevent="saveCategoryLayout()" class="btn btn-bigger-font pull-right">Save</button>
      <a :href="action_url + '/edit'" class="btn btn-transparent pull-right mr-5 mt-2">Canel</a>
    </div>

    <button class="btn btn-primary" @click.prevent="addTextareaField()" :disabled="(all_textarea_fields.length === used_textarea_fields.length)">Add Textarea Field</button>
  </div>
</template>

<script>
import modal from '../components/Modal.vue';
import category_builder_item from '../components/CategoryBuilderItem';

export default {
  components: {modal, category_builder_item},
  props: ['category_edit_layout', 'action_url', 'editable_textarea_fields'],
  data() {
    return {
      layoutArray: this.category_edit_layout,
      all_textarea_fields: this.editable_textarea_fields,
      used_textarea_fields: this.editableFieldsAvailable('textarea'),
    }
  },
  methods: {
    editableFieldsAvailable: function(inputType) {
      // We run through this function to find fields already used.
      let app = this;
      let textFieldNames = [];
      app.category_edit_layout.forEach(function(field_details,i) {
        if(field_details.type === inputType) {
          textFieldNames.push(field_details.machine_name);
        }
      });

      return textFieldNames;
    },
    addField: function () {
      let app = this;
      app.layoutArray.push({
        'name': '',
        'field_label': '',
        'machine_name': '',
        'type': 'text',
      })
    },
    addTextareaField: function () {
      let app = this;
      app.layoutArray.push({
        'field_label': '',
        'machine_name': '',
        'type': 'textarea',
      })
    },
    saveCategoryLayout: function () {
      let app = this;
      window.axios(
          {
            method: 'PUT',
            url: app.action_url,
            params: {
              layout_judge: JSON.stringify(app.layoutArray)
            }
          }).then(function (response) {
        window.location.reload();
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
  }
}
</script>